module.exports = __webpack_public_path__ + "3b4302524bb51ee083dae99cfdae50e5.svg";